import service from '../../http/axios';

// 查询系统病变
export const listSystemLesions = service({
  url: '/yinghe-api/lesionsScience/listSystemLesions',
});
// 查询病变列表
export const listLesions = service({
  url: '/yinghe-api/lesionsScience/listLesions',
});
// 新增或修改病变
export const createLesions = service({
  method: 'POST',
  url: '/yinghe-api/lesionsScience/saveOrUpdateLesions',
});
// 删除病变
export const delLesions = service({
  url: '/yinghe-api/lesionsScience/deleteLesion',
});
// 删除病变定义
export const delResItem = service({
  url: '/yinghe-api/lesionsScience/deleteResultItem',
});
// 删除器官分割单个器官
export const delResExamItem = service({
  url: '/yinghe-api/lesionsScience/deleteLesionExamOption',
});
// 获取病变结果项
export const getLesionsResultItem = service({
  url: '/yinghe-api/lesionsScience/listLesionsResultItem',
});
// 获取参考病变结果项
export const getReferenceLesionsResultItem = service({
  url: '/yinghe-api/lesionsScience/listReferenceLesionsResultItem',
});
// 新增或修改病变结果项目及属性值
export const createLesionsResultItem = service({
  method: 'POST',
  url: '/yinghe-api/lesionsScience/saveOrUpdateLesionsResultItem',
});

/*****************************AI辅助标注MAPPING************************************ */
//获取AI辅助工具选项列表
export const getAIAssistList = service({
  url: '/yinghe-api/aiAa/aiAaList',
});

//获取AI辅助工具Tabs列表数据
export const getAIAssistTabsList = service({
  url: '/yinghe-api/aiAa/getAiAaSettingInfo',
});

// 获取病变列表
export const getListLessonsType = service({
  url: '/yinghe-api/userVsAiSetting/listLessonsType',
});

// 获取病变属性列表
export const getAttributes = service({
  url: '/yinghe-api/tagResult/attributes',
});

// 获取AI辅助工具标签列表 => 项目对应的AI辅助工具标签
export const getAiAaDataList = service({
  url: '/yinghe-api/aiAa/aiAaDetail',
});

// 保存mapping信息
export const saveMapping = service({
  method: 'POST',
  url: '/yinghe-api/aiAa/addAiAA',
});

//删除数据
export const delMapping = service({
  url: '/yinghe-api/aiAa/deleteAiAA',
});

/********************************************************************************* */
